import { Button } from 'common/components/Button/Button'
import { handleError } from 'common/utils/validation/errorHandler'
import Link from 'next/link'
import { toast } from 'react-toastify'
import styled from 'styled-components'
import useSWRMutation from 'swr/mutation'
import { ApiPathsUsers, sendPassword } from '../auth.service'

export const ForgotPasswordInstructions = ({ email }: { email: string }) => {
  //api
  const { trigger, isMutating } = useSWRMutation(ApiPathsUsers.passwordSend, sendPassword, {
    onError(error) {
      handleError(error)
    },
    onSuccess() {
      toast.success('Instructions have been resent')
    },
  })

  const triggerCallback = (email: string) => {
    toast.success(
      "We have resent an email for password reset instructions. If you don't receive an email, kindly review your spam folder and ensure your registration email matches.",
    )
  }
  //handler
  const handleResend = async (e: React.SyntheticEvent) => {
    e.preventDefault()
    await trigger(
      { email },
      {
        onSuccess: () => triggerCallback(email),
        onError: () => triggerCallback(email),
      },
    )
  }

  return (
    <>
      <TextContainer>
        <h3>Instructions have been sent</h3>
        <p>Check your email to reset your password.</p>
      </TextContainer>
      <TextContainer>
        <p className="footerText">No email?</p>
        <StyledButton variant="ghost" className="secondary_100" isLoading={isMutating} onClick={handleResend}>
          Re-send instructions
        </StyledButton>
      </TextContainer>
      <TextContainer>
        <p className="footerText">
          <Link className="secondary_100" href="/login">
            {' '}
            Back to login page
          </Link>
        </p>
      </TextContainer>
    </>
  )
}

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  h3 {
    font-weight: 600;
    font-size: 22px;
    line-height: 140%;
    margin-bottom: 0.5rem;
  }
  p {
    font-weight: 400;
    font-size: 14px;
    line-height: 180%;
  }
  .footerText {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 180%;
  }
  margin-bottom: 2rem;
`

const StyledButton = styled(Button)`
  font-weight: 400;
  font-size: 14px;
  line-height: 180%;
`
